export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Nav ierakstu",
    "notifications.rp_has_been_updated": "Projekts ir atjaunināts",
    "moduleTitle.files": "Faili",
    "label.coordinator": "Koordinators",
    "sidebar.translations_managment": "",
    "table.file": "Fails",
    "label.report_overview": "",
    "label.parent_agreement": "Izdrukājama vecāku atļaujas forma",
    "parentalConsent.i_consent_to_and_understand_that": "6. Es piekrītu un saprotu, ka dalībniekam piedaloties tādās aktivitātēs, kas saistītas ar Award, var tikt uzņemtas bildes, un ka šīs bildes var tikt izmantotas reklāmas nolūkos, ar nosacījumu, ka dalībnieks un viņa vecāki / likumiskie pārstāvji ir parakstījuši atbilstošu atļaujas veidlapu.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Es saprotu, ka dalībniekam ir jāievēro Award prasības, kuras ietvertas Sasniegumu grāmatā vai TSG, politikas un attiecīgā Award operatora uzvedības standartus (kuri laiku pa laikam tiek laboti) un Award vienības prasības, kas saistītas ar rīcību ārkārtas gadījumos, aktivitāšu novērtējumu un Award piedzīvojumu ceļojumu organizēšanu. Esmu informēts/-a, ka Award vienība var pārtraukt dalībnieka dalību, ja netiek ievērotas prasības.",
    "table.end_date": "Beigu datums",
    "label.activation_date": "Aktivizēšanas diena",
    "label.report": "",
    "label.award_is_offline": "Award ir offline",
    "label.pending_changes": "Gaidāmas izmaiņas...",
    "errors.min_nights_required": "Ir vajadzīgas vismaz {nights} naktis",
    "label.country": "Valsts",
    "notifications.award_leader_has_been_returned": "Award vadītājs ir atgiezts",
    "notifications.participant_has_been_updated": "Dalībnieks ir atjaunināts",
    "label.phone_number": "Tālruņa numurs",
    "roles.aj_assessor": "Piedzīvojumu ceļojuma novērtētājs",
    "notifications.person_state_has_been_changed": "Personas statuss ir mainīts",
    "pageTitle.dashboard": "Panelis",
    "moduleTitle.global_payment_method": "Globālais maksāšanas veids",
    "label.organization_type": "Ogranizācijas veids",
    "button.account_settings": "Konta iestatījumi",
    "notifications.contact_has_been_updated": "Kontakts ir atjaunināts",
    "participant.recover_password": "Atjaunot paroli",
    "notifications.assessment_request_has_been_sent": "Novērtēšanas pieprasījums ir nosūtīts",
    "button.unassign": "",
    "label.start_date": "Sākuma datums",
    "label.assign_labels": "",
    "sidebar.participants": "Dalībnieki",
    "roles.coordinator": "Koordinators",
    "label.organization_contact": "Organizācijas kontakti",
    "tabs.customization": "Pielāgojumi",
    "sidebar.award_units": "Award vienības",
    "button.change_goal": "Mainīt mērķi",
    "translationsManagement.selectProject": "",
    "award.rp": "Projekts",
    "label.size": "Izmērs",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Aktivitāte ir apstiprināta",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Vēlreiz nosūtīt lūgumu pēc novērtējuma",
    "notifications.template_has_been_removed": "Veidne ir noņemta",
    "button.award_settings": "Award iestatījumi",
    "pageTitle.payment": "Maksājums",
    "tasks.return_award": "Atgriezt pieteikumu apbalvojuma saņemšanai",
    "label.link": "saite",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Mans reģionālais birojs - saistītie kontakti",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Jomas pabeigšanas apstiprināšana",
    "table.logs": "Ieraksti",
    "moduleTitle.remove_file": "Noņemt failu?",
    "label.email_confirmed": "E-pasts apstiprināts",
    "notifications.activity_has_been_returned": "Aktivitāte ir atgriezta",
    "label.note": "Piezīme",
    "button.show": "",
    "tabs.adventurous_journey": "Piedzīvojumu ceļojums",
    "sidebar.my_todolist": "",
    "label.here": "šeit",
    "organisation.change_award_mode": "Mainit Award režīmu",
    "table.note_from_al": "Ziņa Award vadītājam",
    "label.gender": "Dzimums",
    "moduleTitle.remove": "Noņemt?",
    "errors.must_be_less_than": "Jābūt mazākam par {limit}",
    "button.logout": "Izlogoties",
    "label.no_selected_participants": "Dalībnieki nav atlasīti",
    "button.new_aj_event": "Jauns piedzīvojumu ceļojuma notikums",
    "label.employement_status": "Nodarbinātības statuss",
    "tabs.logs": "Ieraksti",
    "tabs.contacts": "Kontakti",
    "label.option": "Iespējas",
    "dashboard.charts": "Diagrammas",
    "notifications.rp_has_been_approved": "Projekts ir apstiprināts",
    "pageTitle.new_participant": "Jauns dalībnieks",
    "notifications.award_leader_has_been_approved": "Award vadītājs ir apstiprināts",
    "moduleTitle.would_you_like_to_remove_leader_training": "Vai vēlies dzēst Award vadītāju apmācības?",
    "moduleTitle.update_configuration_value": "Atjaunināt konfigurācijas vērtību",
    "table.description": "Apraksts",
    "table.organization": "Organizācija",
    "label.youtube": "YouTube",
    "label.author": "Autors",
    "table.suitable_for_award_level": "Piemērots Award līmenim",
    "label.content_update": "Uzgaidi. Notiek satura atjaunināšana...",
    "notifications.new_question_has_been_added": "Pievienots jauns jautājums",
    "pageTitle.nao_awards": "Nacionālais birojs - apbalvojumi",
    "table.last_name": "Uzvārds",
    "moduleTitle.adventurous_journey_detail": "Informācija par ceļojumu",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Projekta vietas veids",
    "label.email_help_award_level": "",
    "label.date": "Datums",
    "label.previous_completed_award_place": "Kur",
    "button.show_more": "Rādīt vairāk",
    "label.wwc_number": "WWC number",
    "button.filter": "Filtrs",
    "notifications.rp_has_been_returned": "Projekts ir atgriezts",
    "pageTitle.residetial_project_assessor_report": "Projekts - novērtētāja pārskats",
    "label.generating": "",
    "moduleTitle.finance_system_data": "Finanšu sistēmas dati",
    "notifications.adventurous_journey_state_has_been_changed": "Piedzīvojumu ceļojuma statuss ir mainīts",
    "route.levels": "Līmeņi",
    "moduleTitle.activity_leader": "Aktivitātes vadītājs",
    "tasks.approve_event": "Apstiprināt notikumu",
    "tasks.reject_event": "Atgriezt notikumu",
    "table.region": "Reģions",
    "pageTitle.nao_award_leaders": "Nacionālais birojs - Award vadītāji",
    "errors.must_be_at_least": "Jābūt vismaz {min} rakstzīmēm",
    "table.title": "Title",
    "table.last_activity": "Pēdējā aktivitāte",
    "tasks.delete_registration": "Dzēst reģistrāciju",
    "table.date_time": "Datums / Laiks",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Award operators apņemas respektēt Jūsu privātumu. Šajā platformā savāktā informācija ir nepeiciešama, lai dalībnieks varētu piedalīties Award. Dalībnieki, kas nesniedz šo informāciju, nevar piedalīties Award. Tāpat mēs varam izmantot šo informāciju, lai sūtītu Jums informāciju par Award aktivitātēm vai notikumiem, kuri, mūsuprāt, varētu būt Jums saistoši. Mēs varam atklāt šo informāciju citām vietējām vai starptautiskām organizācijām un pakalpojumu sniedzējiem, kuri atbalsta mūs Award īstenošanā un organizēšanā. Ja Jūs vēlaties sazināties ar mums vai piekļūt savai privātajai informācijai, lūdzam rakstīt Award operatoram. Jūs varat sazināties ar Award Operatoru, lai pieprasītu ziņas par privātuma politiku.",
    "aj.practice_journey": "Izmēģinājuma ceļojums",
    "notification.log_has_been_restored": "Ieraksts par aktivitāti ir atgriezts",
    "tabs.my_participants": "Mani dalībnieki",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Uzraugs",
    "moduleTitle.your_parental_consent": "Tavu vecāku atļauja",
    "route.registration_participants": "Dalībnieku reģistrēšana",
    "placeholder.start_typing": "Sākt rakstīt...",
    "tasks.approve_award": "Apstiprināt apbalvojuma saņemšanai",
    "route.registrations": "Reģistrācijas",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "Piedzīvojumu ceļojums ir izveidots",
    "states.supervisor_approval": "Novērtētāja apstiprinājums",
    "label.description": "Apraksts",
    "button.leave_anyway": "Jebkurā gadījumā pamest",
    "tabs.registrations": "Reģistrācijas",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "Nacionālais birojs - reģistrācija",
    "pageTitle.mro_logs": "Mans reģionālais birojs - ieraksti",
    "meta.page_not_found": "Lapa nav atrasta",
    "label.bulk_action_unsuccessful": "",
    "global.days": "dienas",
    "table.review": "Pārskats",
    "table.as_assessor_for": "Kā novērtētājs",
    "roles.if_staff_statistical_user": "IF Statistical User",
    "table.levels": "Līmeņi",
    "label.suitable_for_level": "Piemērots līmenim",
    "pageTitle.leaders": "Vadītāji",
    "moduleTitle.send_test_email": "Sūtīt izmēģinājuma e-pastu",
    "pageTitle.tasks_removed_registration": "Noņemto dalībnieku reģistrācijas",
    "label.you_will_be_forced_to_login_again_after_change": "Pēc veiktajām izmaiņām tev vajadzēs ielogoties no jauna",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Apstiprināt jomas pabeigšanu",
    "pageTitle.payments": "Maksājumi",
    "global.nights": "naktis",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Izvēlēties organizāciju",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Augšupielādēt failu",
    "label.migrated_contact_email": "Pārcelto kontaktu e-pasts",
    "label.for_award_unit": "Priekš Award vienības",
    "label.aj_template_note": "Veidnes piezīmes",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "Lūdzam sniegt komentārus par dalībnieka veikumu",
    "label.consent_already_given_login": "Atļauja jau ir dota. Ielogojieties kā bērns.",
    "participant.level_start_date": "{value} sākuma datums",
    "sidebar.my_region_office": "Mans reģionālais birojs",
    "states.section_signoff": "Jomas pabeigšanas apstiprinājums",
    "moduleTitle.assessor_details": "Informācija par novērtētāju",
    "moduleTitle.adventurous_journey_settings": "Piedzīvojumu ceļojuma iestatījumi",
    "moduleTitle.note_from_al": "Ziņa no Award vadītāja",
    "button.add_role": "Pievienot lomu",
    "table.run": "Palaist",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "Award vadītāju lietotnes lietošanas pamācība",
    "tabs.section_approval": "Jomas apstiprinājums",
    "roles.award_verifier": "Award apliecinātājs",
    "tabs.activity_approval": "Aktivitātes apstiprinājums",
    "logs.add_log": "Pievienot ierakstu",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "Šai lomai ir tikai lasīšanas atļauja",
    "table.no_filtered_results": "Nav atlasīto rezultātu",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Informācija par vietu",
    "label.optional": "(nav obligāta)",
    "errors.do_not_match": "Nesakrīt",
    "label.use_comma_for_multiple_entries": "Izmanto komatu, lai atdalītu vairākus ierakstus",
    "label.operating_authority": "Izpildoperators",
    "label.activity_section": "Award joma",
    "notifications.you_have_been_logged_out": "Tu esi izlogots",
    "table.finished": "Pabeigts",
    "button.same_as_billing": "Tāds pats kā norēķiniem",
    "table.payment": "Maksājums",
    "table.current_level": "Šī brīža līmenis",
    "button.view_nao": "",
    "table.email_confirmation": "E-pasta apstiprinājums",
    "moduleTitle.shipping_address": "Piegādes adrese",
    "label.secondary_phone_type": "Sekundārā tālruņa veids",
    "notifications.saved": "Saglabāts",
    "pageTitle.all_participants": "Visi dalībnieki",
    "label.first_name": "Vārds",
    "label.oa_price": "OA cena",
    "table.award_mode": "Award režīms",
    "tabs.api_keys": "",
    "award.award_detail": "Informācija par Award",
    "tabs.user_management": "Lietotāju pārvalde",
    "tabs.all_events": "Visi notikumi",
    "notifications.history_record_has_been_removed": "Vēstures ieraksts ir noņemts",
    "award.no_data": "Nav datu",
    "notifications.preparation_training_has_been_added": "Sagatavošanās un apmācības ir pievienotas",
    "label.message": "Ziņa",
    "notifications.participant_info_updated": "Informācija par dalībnieku ir atjaunināta",
    "roles.nao_staff": "NAO personāls",
    "tabs.adventurous_journeys": "Piedzīvojumu ceļojums",
    "label.gops": "",
    "route.upload": "Augšupielādēt",
    "notifications.history_record_has_been_added": "Vēstures ieraksts ir pievienots",
    "notifications.history_record_has_been_updated": "Vēstures ieraksts ir atjaunināts",
    "label.no_data": "Nav datu",
    "button.add_coordinator": "Pievienot koordinatoru",
    "label.you_are_already_logged_as": "Tu esi ielōgojies kā ",
    "route.my_national_office": "Mans nacionālais birojs",
    "tabs.leaders": "Vadītāji",
    "label.email_confirmation": "E-pasta apstiprinājums",
    "table.registration_date": "Reģistrēšanas datums",
    "notifications.role_has_been_removed": "Loma ir noņemta",
    "button.move": "Pārvietot",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Informācija",
    "table.award_unit": "Award vienība",
    "sidebar.settings": "Iestatījumi",
    "dashboard.leader_state": "Vadītāji - pēc statusa",
    "notifications.award_unit_has_been_approved": "Award vienība ir apstiprināta",
    "states.awaiting_approval": "Gaida apstiprinājumu",
    "table.level": "Līmenis",
    "table.action_requested": "",
    "label.organisation_mode": "Organizācijas režīms",
    "label.no_note": "Nav piezīmju",
    "tabs.my_events": "Mani notikumi",
    "notifications.participants_have_been_added": "Dalībnieki ir pievienoti",
    "tabs.registration_questions": "",
    "button.delete_registration": "Dzēst reģistrāciju",
    "notifications.parental_consent_link_has_been_sent": "Saite uz vecāku atļauju ir nosūtīta",
    "moduleTitle.select_role_organization": "Izvēlēties lomu un organizāciju",
    "label.experience": "Pieredze",
    "translationsManagement.modal.title": "",
    "table.ic": "Neatkarīga valsts",
    "table.id": "ID",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Vai vēlies dzēst šo kontu?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "Pamācība Award vadītājam - tīmekļa lietotājam",
    "label.journey_type": "Ceļojuma veids",
    "button.setup": "Uzstādīt",
    "tabs.my_national_office": "Mans nacionālais birojs",
    "notifications.training_has_been_removed": "Apmācības ir noņemtas",
    "label.nominated_and_identified_persons": "Nominētā persona, kura var skatīties datus, bet nevar tos labot",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Darba seansa laika limits beidzies, seanss pārtraukts.",
    "states.award_leader_signoff": "Award vadītāja apstiprinājums",
    "table.award_signoff_attempts": "Mēģinājumi pieteikties apbalvojuma saņemšanai",
    "sidebar.regions": "Reģioni",
    "label.activity_deleted_note": "Šī aktivitāte ir dzēsta. Tu vari to atjaunot, nospiežot zemāk esošo pogu",
    "table.total": "Kopumā",
    "errors.a_problem_has_occured_during_processing": "Apstrādes laikā radās problēma, skatiet vairāk informācijas",
    "participant.participant_already_has_gold_award": "Dalībniekam jau ir Zelta apbalvojums",
    "pageTitle.mro": "Mans reģionālais birojs",
    "notifications.authorization_code_has_expired": "Autorizēšanās koda darbības termiņš ir beidzies",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Piedzīvojumu ceļojuma notikumi",
    "global.loading": "Notiek ielāde",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Reģistrācijas",
    "label.any_string": "Jebkurš pavediens",
    "contact.change_contact_status": "Mainīt kontakta statusu",
    "tabs.registration": "Reģistrācija",
    "label.override_payment_note": "Override payment note",
    "notifications.section_has_been_signed_off": "Jomas pabeigšana ir apstiprināta",
    "label.payment_date": "Maksājuma diena",
    "button.approve": "Apstiprināt",
    "moduleTitle.loggin_in": "Ielogošanās",
    "label.website": "Mājaslapa",
    "label.role": "Loma",
    "table.assessor_report": "Novērtētāja pārskats",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Iepriekš darbojos kā novērtētājs",
    "pageTitle.registrations": "Reģistrācijas",
    "parentalConsent.this_form_must_be_completed": "Šo formu <strong>obligāti</strong> jāaizpilda <strong> nepilngadīgo dalībnieku vecākiem / likumiskajiem pārstāvjiem </strong>",
    "button.apply": "",
    "errors.include_at_least_one_number": "Iekļauj vismaz vienu ciparu",
    "label.content_restore": "Atjauno sesiju...",
    "logs.hour": "stunda",
    "parentalConsent.i_have_read_and_understand": "7. Es izlasīju un saprotu dažādos Award līmeņus un prasības, kuras ir izklāstītas Award aprakstā (formas 5.lapā)",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Ceļojuma kategorija",
    "notifications.search_cancelled": "Meklēšana tika pārtraukta, tev jāsagaida, kad beigsies meklēšana.",
    "route.detail": "Informācija",
    "route.user_guide": "Pamācība lietotājam",
    "moduleTitle.history": "Vēsture",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Dalībnieki bez Award vadītāja",
    "states.inactive": "Neaktīvs",
    "pageTitle.search_results": "Meklēšanas rezultāti",
    "button.proceed_to_login": "Turpināt ielogošanos",
    "pageTitle.assessor_report_reject": "Novērtētāja pārskata noraidīšana",
    "notifications.contact_has_been_removed": "Kontakts ir noņemts",
    "sidebar.operating_authorities": "Izpildoperatori",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Sagatavošanās un apmācības",
    "route.user_guide_web_leader": "Pamācība Award vadītājam - tīmekļa lietotājam",
    "label.position_in_organization": "Loma organizācijā",
    "errors.emails_dont_match": "E-pasta adreses nesakrīt",
    "route.my_participants": "Mani dalībnieki",
    "pageTitle.customisations": "Pielāgojumi",
    "tabs.localization_files": "Lokalizācijas faili",
    "table.assessor_approval": "Novērtētāja apstiprinājums",
    "tabs.related_contacts": "Saistītie kontakti",
    "table.aus": "Award vienības",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Iespējamās vērtības:",
    "label.if_your_download_doesnt_start": "Ja lejupielāde nesākas automātiski, tad klikšķi šeit",
    "route.independent_award_centres": "Neatkarīgie Award centri",
    "pageTitle.user_guide": "Pamācības lietotājiem",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Mana organizācija - informācija",
    "pageTitle.nao_detail": "Nacionālais birojs - informācija",
    "button.change": "Mainīt",
    "award.aj": "Piedzīvojumu ceļojums",
    "table.award_state": "Award stāvoklis",
    "pageTitle.tasks_award_signoff": "Apstiprināt apbalvojuma saņemšanai",
    "pageTitle.regions": "Reģioni",
    "notifications.award_has_been_signed_off": "Apstiprināts apbalvojuma saņemšanai",
    "dashboard.award_approved_by": "Piešķirtie apbalvojumi - pa līmeņiem 2016.gadā",
    "tabs.new_template": "Jauna veidne",
    "error.parent_email_must_be_filled": "",
    "label.organisation_invoicing_name": "Organizācijas, kas izraksta rēķinu, nosaukums",
    "pageTitle.related_contacts": "Saistītie kontakti",
    "button.try_again": "Aizvērt brīdinājumu un mēģināt vēlreiz",
    "label.cannot_be_change_to_another": "Nevar tikt mainīts uz citu Award līmeni",
    "notifications.lead_coordinator_has_been_set": "Izveidots jauns vadošais koordinators",
    "label.training_name": "Apmācību nosaukums",
    "moduleTitle.new_contact": "Jauns kontakts",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "Offline Award vadītāja izlogošana",
    "notifications.award_level_has_been_changed": "Award līmenis ir mainīts",
    "label.subject": "Temats",
    "route.silver_level": "Sudraba līmenis",
    "label.privacy_notice": "",
    "label.switch_organization": "Pārslēgt organizāciju",
    "meta.dofe_name": "The Duke of Edinburgh’s International Award",
    "route.profile": "Profils",
    "roles.super_user": "Super-lietotājs",
    "dashboard.while_you_were_gone": "Kamēr biji prom",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Otrais vārds",
    "moduleTitle.new_activity": "Jauna aktivitāte",
    "organisation.would_you_like_to_remove": "Vai vēlies noņemt šo organizāciju?",
    "label.state_province": "Pašvaldība",
    "moduleTitle.your_home_address": "Dzīvesvietas adrese",
    "tabs.sign_offs": "Apstiprinājumi",
    "moduleTitle.logs": "Ieraksti",
    "button.view_more": "Skatīt vairāk",
    "label.profile": "Profils",
    "label.title": "Uzruna",
    "tabs.award_signoff": "Pieteikuma apbalvojuma saņemšanai apstiprināšana",
    "label.post_code": "Pasta indekss",
    "states.ceremony_certificate": "Apbalvošana",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Es piekrītu iesniegt visu personisko informāciju, ko esmu norādījis/-usi (ieskatot dalībnieka datus), Award vienībai un Award operatoram. Es piekrītu, ka šī informācija tiek izmantota saskaņā ar attiecīgā Award operatora noteikto privātuma politiku un citiem normatīvajiem aktiem, standartiem, vadlīnijām vai instrukcijām.",
    "label.user_guide_web_participant": "Pamācība dalībniekam - tīmekļa lietotājam",
    "label.award_unit_type": "Award vienības veids",
    "states.complete": "",
    "table.participant_state": "Dalībnieka statuss",
    "pageTitle.my_organization_payment": "Mana organizācija - maksājums",
    "table.approved": "Apstiprināts",
    "pageTitle.my_organization_contacts": "Mana organizācija - kontakti",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Mainīt uz <strong>{state}</strong>",
    "label.integer": "Vesels skaitlis",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "Parole ir nomainīta",
    "button.invite_assessor": "Uzaicināt novērtētāju",
    "label.other_activity": "Citas aktivitātes",
    "notifications.parental_consent_has_been_sent": "Vecāku atļauja ir nosūtīta",
    "button.revise": "Atgriezt",
    "errors.end_date_must_be_after_start_date": "Beigu datumam jābūt pēc sākuma datuma",
    "label.award_leader_signoff_date": "Datums, kad Award vadītājs apstiprināja pietiekumu apbalvojuma saņemšanai",
    "parentalConsent.i_understand_every_participant_must": "8. Es saprotu, ka katram dalībniekam jābūt saistītam ar kādu Award vienību, kas patur tiesības pieņemt vai noraidīt dalībniekus vai dalībnieku izraudzītās Award aktivitātes.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Piedzīvojumu ceļojums",
    "global.day": "diena",
    "moduleTitle.coordinator": "Koordinators",
    "label.region": "Reģions",
    "button.add_history_record": "Pievienot vēstures ierakstu",
    "moduleTitle.adventurous_journey_template_settings": "Piedzīvojumu ceļojuma veidnes iestatījumi",
    "notifications.personal_details_have_been_updated": "Dati ir atjaunināti",
    "sidebar.ics": "Independent Countries (GBT)",
    "table.independent_award_centre": "Neatkarīgs Award centrs",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "E-pasts",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "Vecāku / likumisko pārstāvju atļauja",
    "label.photo_consent_given": "Dalībnieks/-ce piekrīt, ka mēs varam izmantot viņa/viņas profila bildi Award atpazīstamības veicināšanas nolūkos",
    "moduleTitle.authorising_contact": "Pilnvarotā kontaktpersona",
    "label.assessment_with_role": "{role} novērtējums",
    "dashboard.type_of_awards": "Award vienības veids",
    "moduleTitle.payment": "Maksājums",
    "states.in_progress": "Progresā",
    "logs.no_logs": "Nav ierakstu",
    "sidebar.my_office": "Mans birojs",
    "label.assessor_report": "Novērtētāja pārskats",
    "notifications.rp_has_been_signed_off": "Apstiprināta projekta pabeigšana",
    "tabs.labels": "",
    "sidebar.payments": "Maksājumi",
    "meta.profile_questions": "Profila jautājumi",
    "label.fax": "Fakss",
    "label.email_help_custom_link": "",
    "label.last_name": "Uzvārds",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Dalībnieki - pa līmeņiem",
    "tabs.award_leaders": "Award vadītāji",
    "label.i_confirm_that_ive_witnessed": "Es apstiprinu, ka esmu iepazinies ar dalībnieka veiktajiem ierakstiem",
    "table.lead_coordinator": "",
    "states.deleted": "Dzēsts",
    "label.no_answers": "Nav atbilžu",
    "button.add": "Pievienot",
    "label.exchequer_number": "Valsts kases numurs",
    "label.waiting": "Gaida",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Atgriezt reģistrāciju",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Vecāku atļauja",
    "table.assessor_approve": "Novērtētāja apstiprinājums",
    "errors.some_fields_requires_your_attention": "Tev jāpieērš uzmanība dažiem laukiem",
    "aj.qualifying_journey": "Ieskaites ceļojums",
    "route.awards": "Apbalvojumi",
    "table.registration": "Reģistrācija",
    "pageTitle.assessors": "Novērtētāji",
    "notifications.award_has_been_updated": "Award ir atjaunināts",
    "errors.must_be_one_of": "Jābūt vismaz vienam no: {enums}",
    "pageTitle.logs": "Ieraksti",
    "notifications.notifications.invitation_has_been_sent": "Uzaicinājums ir nosūtīts",
    "route.national_offices": "Nacionālie biroji",
    "notifications.training_has_been_updated": "Apmācības ir atjauninātas",
    "label.parent_last_name": "Tēva vai mātes / likumiskā pārstāvja uzvārds",
    "table.leaders": "Vadītāji",
    "states.award_level_complete": "Award līmenis pabeigts",
    "button.reset": "Atjaunot",
    "sidebar.my_award_unit": "Mana Award vienība",
    "pageTitle.all_aj_events": "Visi piedzīvojumu ceļojuma notikumi",
    "label.activity": "Aktivitāte",
    "moduleTitle.are_you_sure": "Vai tiešām?",
    "route.gold_level": "Zelta līmenis",
    "table.evidence": "Pierādījums",
    "label.delivery_confirmed": "Piegāde apstiprināta",
    "parentalConsent.as_the_parent": "Kā māte/tēvs / likumiskais pārstāvis, es dodu savu atļauju tam, ka attēlus, Award atpazīstamības veicināšanas nolūkos, var izmantot Fonds.",
    "label.awardMode.offline": "Bezsaistē",
    "tasks.approve_registration": "Apstiprināt reģistrāciju",
    "note.change_the_email_will_change": "Piezīme: Mainot e-pastu tiks mainīta arī pārnestā kontakta e-pasts",
    "notifications.participant_has_been_approved": "Dalībnieks ir apstiprināts",
    "label.reached_activity_limit": "Šajā jomā sasniegts aktivitāšu limits. Dalībnieks katrā jomā var izvēlēties maksimums 3 aktivitātes.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Sagatavošanās un apmācības ir noņemtas",
    "pageTitle.settings": "Iestatījumi",
    "participant.level_registration_date": "{value} reģistrēšanās diena",
    "notifications.question_has_been_removed": "Jautājums ir noņemts",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Vadītāji",
    "notifications.participants_have_been_transferred": "Dalībnieki ir nodoti",
    "tabs.assessors": "Novērtētāji",
    "sidebar.dashboard": "Panelis",
    "pageTitle.independent_award_centers": "Neatkarīgie Award centri",
    "label.search": "Meklēt",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Ziņa no dalībnieka",
    "errors.required_field": "Obligātais lauks",
    "tasks.approve_task": "Apstiprināt vienību",
    "logs.edit_log": "Labot ierakstu",
    "table.state": "Statuss",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Aizvērt",
    "label.parent_first_name": "Tēva vai mātes / likumiskā pārstāvja vārds",
    "parentalConsent.i_understand_that_the_participant": "1. Es saprotu, ka dalībnieks nevar piedalīties Award, kamēr šī forma nav aizpildīta (ieskaitot vecāku / likumisko pārstāvju atļauju) un līdz ar attiecīgās reģistrācijas maksu iesniegta attiecīgajam Award operatoram, un nav akceptēta no Award vienības puses.",
    "tabs.award_units": "Award vienības",
    "table.hours": "Stundas",
    "label.type": "Veids",
    "notifications.adventurous_journey_has_been_removed": "Piedzīvojumu ceļojums ir noņemts",
    "label.aj_is_not_approved_yet": "Piedzīvojumu ceļojums pagaidām nav apstiprināts",
    "roles.authorizing_contact": "Pilnvarotā kontaktpersona",
    "table.date_submitted_to_office_signoff": "Diena, ka pieteikums iesniegts apstiprināšanai Award birojam",
    "notifications.section_has_been_returned": "Joma ir atgriezta",
    "table.created_by": "Izveidoja",
    "route.user_guide_web_participant": "Pamācība dalībniekam - tīmekļa lietotājam",
    "route.templates": "Veidnes",
    "states.awaiting_sign_off": "Award vadītāja apstiprinājums",
    "table.phone": "Tālrunis",
    "label.parental_consent": "Vecāku atļauja",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Bronzas līmenis",
    "label.invoice_currency": "Rēķina valūta",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Šobrīd serveris nav sasniedzams. Lūdzam mēģināt vēlāk. Ja problēma nav novērsta, lūdzam sazināties ar tavu atbalsta komandu.",
    "notifications.contact_has_been_created": "Kontakts ir izveidots",
    "pageTitle.profile_questions": "Profila jautājumi",
    "table.observation_files": "Novērojumu faili",
    "table.participants": "Dalībnieki",
    "tasks.no_evidence": "Nav uzrādīti pierādījumi",
    "button.edit": "Labot",
    "moduleTitle.leader": "Vadītājs",
    "notifications.new_template_has_been_updated": "Jaunā veidne ir atjaunināta",
    "table.name": "Vārds",
    "label.no_results": "Nav rezultātu",
    "moduleTitle.documents": "Dokumenti",
    "button.invite": "Uzaicināt",
    "label.goal": "Mērķis",
    "pageTitle.nao_award_units": "Nacionālais birojs - Award vienības",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Vismaz {length} rakstzīmes",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Noņemt lomu?",
    "label.total": "Kopumā",
    "label.delete_participant_award_info": "",
    "route.leaders": "Vadītāji",
    "table.start_date": "Sākuma datums",
    "moduleTitle.coordinators": "Koordinatori",
    "button.create": "Izveidot",
    "tabs.awards": "Apbalvojumi",
    "parentalConsent.form_has_been_sent": "Vecāku atļauja ir nosūtīta",
    "states.journey_approval": "Ceļojuma apstiprināšana",
    "pageTitle.reports": "Pārskati",
    "table.journey_type": "Ceļojuma veids",
    "label.yes": "Jā",
    "pageTitle.assessor_report": "Novērtētāja pārskats",
    "label.organization": "Organizācija",
    "notifications.award_leader_has_been_updated": "Award vadītājs ir atjaunināts",
    "moduleTitle.edit_role": "Labot lomu",
    "table.journey_activity": "Ceļojuma aktivitāte",
    "label.location": "Vieta",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Piedzīvojumu ceļojums",
    "global.assessor": "Novērtētājs",
    "moduleTitle.profile_questions": "Profila jautājumi",
    "activity.cannot_edit_activity_if_award_in_state": "Nevar mainīt aktivitāti, ja Award ir {state} stāvoklī",
    "moduleTitle.assessor_detail": "Informācija par novērtētāju",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Es saprotu, ka tiklīdz dalībnieks būs apstiprināts Award vienībā, viņš saņems Sasniegumu grāmatu vai piekļuvi Tiešsaistes sasniegumu grāmatai (TSG). Dalībnieks iepazīsies ar Sasniegumu grāmatā vai TSG iekļautajām Award prasībām pirms tiek uzsāktas kādas aktivitātes, kas saistītas ar Award. Es saprotu, ka Award vienība var lemt par to, vai ir izpildītas Award prasības, kas dotu pamatu pieškirt dalībniekam bronzas, sudraba vai zelta apbalvojumu.\n\nEs saprotu, ka esmu atbildīgs par dalībnieka apdrošināšanu.",
    "notifications.award_has_been_returned": "Atgriezts pieteikums apbalvojuma saņemšanai",
    "label.code_of_conduct": "",
    "button.new_contact": "Jauns kontakts",
    "tabs.payments": "Maksājumi",
    "roles.naa_oa_staff": "NAA OA darbinieks",
    "label.switch_organisation_hint": "Šis dialoglogs var tikt atvērts jebkurā brīdī, izvēloties \"Pārslēgt organizāciju\", kas atrodas labā-augšējā  stūra izvelnē",
    "label.expiration_date": "Darbības termiņa beigas",
    "tabs.participants": "Dalībnieki",
    "table.practice": "Izmēģinājums",
    "notifications.one_activity_has_to_remain": "Vienai no jomas aktivitātēm vajag palikt aktīvai",
    "label.qualifications": "Kvalifikācija",
    "states.organization_approval": "Nacionālā biroja apstiprinājums apbalvojuma piešķiršanai",
    "errors.must_be_an_integer": "Jābūt veselam skaitlim",
    "participant.send_confirmation_email_again_question": "Nosūtīt apstiprinājuma e-pastu vēlreiz?",
    "button.dismiss": "Atmest",
    "table.advice": "",
    "label.years_of_working_experience": "Darba pieredze (gados)",
    "notifications.search_failed": "Meklējot, radusies kļūda. Lūdzam mēģināt vēlāk.",
    "notifications.changes_have_been_saved": "Izmaiņas ir saglabātas",
    "moduleTitle.resend_parental_consent_link": "Vai saiti uz vecāku atļauju sūtīt vēlreiz?",
    "label.activity_type": "Aktivitātes veids",
    "label.change_award": "Mainīt Award līmeni",
    "label.email": "E-pasts",
    "button.remove": "Noņemt",
    "button.download": "Lejupielādēt",
    "label.vat_treatment": "PVN uzskaites princips",
    "pageTitle.aj_template_new": "Jauna piedzīvojumu ceļojuma veidne",
    "table.per_page": "vienā lapā",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "Award režīms ir atjaunināts",
    "tasks.revise_item": "Noraidīt",
    "button.resend_parental_consent": "Sūtīt atkārtoti vecāku atļauju",
    "table.weeks_completed_required": "Nedēļas pabeigtas / vajadzīgas",
    "label.last_modified": "Pēdējo reizi pārveidots",
    "table.major": "\"Garākā joma\"",
    "label.vat_number": "PVN",
    "errors.passwords_dont_match": "Paroles nesakrīt",
    "table.country": "Valsts",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Jautājums ir atjaunināts",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Autorizēšanās kodam beidzies darbības termiņš",
    "errors.must_be_no_more_than": "Nevar būt vairāk kā {max} rakstzīmes",
    "notifications.event_has_been_rejected": "Notikums ir atgriezts",
    "tabs.customizations": "Pielāgojumi",
    "label.name_organization": "Nosaukums",
    "button.add_log": "Pievienot ierakstu",
    "moduleTitle.invite_assessor": "Uzaicināt novērtētāju",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "Visi dalībnieki tiks nodoti jaunajam Award vadītājam",
    "label.repeat_email": "Ievadīt e-pastu vēlreiz",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Atjaunināta loma",
    "roles.if_staff_stat_user": "IF Statistical User",
    "participant.delete_account": "Dzēst kontu",
    "moduleTitle.would_you_like_to_remove_this_log": "Vai tu vēlētos dzēst šo ieraktu?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Ceļojuma kategorija",
    "sidebar.manual_data_import": "Manuālā datu importēšana",
    "label.created_after_date": "",
    "route.my_organization": "Mana organizācija",
    "button.show_list": "",
    "label.leaders": "Vadītāji",
    "notifications.log_has_been_modified": "Ieraksts ir pārveidots",
    "button.upload_file": "Augšupielādēt failu",
    "moduleTitle.which_section_do_you_want_to": "Kurai jomai vēlies atjaunot statusu \"Progresā\"?",
    "tabs.bronze_level": "Bronzas līmenis",
    "notifications.participants_have_been_saved": "Dalībnieki ir saglabāti",
    "pageTitle.aj_template_detail": "Piedzīvojumu ceļojums",
    "label.parent_email": "Tēva vai mātes / likumiskā pārstāvja e-pasts",
    "map.appr_location": "Aptuvenā adrese",
    "notifications.log_has_been_removed": "Ieraksts ir noņemts",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "Palikt",
    "table.previous_level": "Iepriekšējais līmenis",
    "label.award_start_date": "Award sākuma datums",
    "assessor_report.returned_to_participant": "Atgriezts dalībniekam",
    "pageTitle.tasks_assessors_registration": "Novērtētāja reģistrācija",
    "aj.cannot_modify_award": "Nevar mainīt Award līmeni, ja dalībnieks ir saistīts ar piedzīvojumu ceļojumu",
    "moduleTitle.lost_internet_connection": "Šķiet, ir pazudis interneta savienojums",
    "states.ceremony": "Apbalvošana",
    "participant.reactivate_account": "Re-aktivizēt kontu",
    "label.birthdate": "Dzimšanas datums",
    "pageTitle.assessment_send_successfully": "Novērtējums veiksmīgi nosūtīts",
    "states.assessor_approval": "Novērtētāja apstiprinājums",
    "award.change_award_level": "Mainīt Award līmeni",
    "label.url_no_longer_valid": "URL vairs nav derīgs",
    "button.update": "Atjaunināt",
    "label.secondary_email": "Sekundārais e-pasts",
    "button.role_edit": "Labot",
    "table.award_leader": "Award vadītājs",
    "label.level": "Līmenis",
    "tasks.evidence": "Pierādījums",
    "notifications.participant_is_already_in_list": "Dalībnieks jau ir sarakstā",
    "button.clear": "Nodzēst",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Izveidošana",
    "table.activity": "Aktivitāte",
    "label.copy_to_clipboard": "",
    "route.award_units": "Award vienības",
    "button.upload_photo": "Augšupielādēt attēlu",
    "table.hours_completed_required": "Stundas pabeigtas / vajadzīgas",
    "table.first_name": "Vārds",
    "notifications.adventurous_journey_has_been_returned": "Piedzīvojumu ceļojums ir atgriezts",
    "pageTitle.national_offices": "Nacionālie biroji",
    "notifications.you_have_been_logged_in": "Tu esi ielogojies",
    "logs.offline": "",
    "moduleTitle.add_role": "Pievienot lomu",
    "label.user_app_guide_participant": "Dalībnieku lietotnes lietošanas pamācība",
    "notifications.file_has_been_removed": "Fails ir noņemts",
    "label.send_message": "",
    "button.select": "Izvēlēties",
    "label.reason_of_deletion": "Dzēšanas iemesls",
    "label.user_guide": "Pamācība lietotājam",
    "pageTitle.nao_participants": "Nacionālais birojs - Award dalībnieki",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Augšupielādēja",
    "tasks.approve_item": "Apstiprināt",
    "tasks.restore_participant_registration": "Atjaunot dalībnieka reģistrāciju?",
    "label.awardMode.hybrid": "Hibrīds",
    "table.first_activity_started": "Pirmā aktivitāte uzsākta",
    "moduleTitle.dates": "Datumi",
    "table.no_results": "Nav rezultātu",
    "states.registration_approval": "Reģistrācijas apstiprinājums",
    "table.breakdown_of_hours": "Stundu pārrāvums",
    "pageTitle.tasks_registration": "Dalībnieka reģistrācija",
    "button.create_new": "Izveidot jaunu",
    "sidebar.todolist": "Darāmo lietu saraksts",
    "label.active_participants": "Aktīvs dalībnieks",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Atgriezt uzdevumu",
    "organisation.change_organisation_state": "Mainīt organizācijas stāvokli",
    "moduleTitle.roles": "Lomas",
    "label.no_config_key_available": "Šai sadaļai nav pieejama konfigurācijas atslēga",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "Nacionālā biroja apstiprinājums apbalvojuma piešķiršanai",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "minūte",
    "label.last_activity": "Pēdējā aktivitāte",
    "sidebar.user_guide": "Pamācības lietotājiem",
    "label.trained_award_leader": "apmācīts Award vadītājs",
    "table.progress": "Progress",
    "table.suboperating_authorities": "Apakš-operatori",
    "activity.cannot_edit_activity_offline": "Šis dalībnieks darbojas bezsaistes režīmā.<br><br>\nTu nevari rediģēt: aktivitāti, piedzīvojumu ceļojumu vai zelta projeku, ja Award ir daļējā bezsaistes režīmā.",
    "label.user_does_not_have_permissions": "Lietotājam <strong>{user}</strong> nav atļauts redzēt šo saturu.",
    "notifications.assessor_has_been_approved": "Novērtētājs ir apstiprināts",
    "route.activity_approval": "Aktivitātes apstiprināšana",
    "moduleTitle.role": "Loma",
    "button.run": "Palaist",
    "label.to": "Kam",
    "notifications.file_has_been_updated": "Fails ir atjaunināts",
    "moduleTitle.edit_coordinator": "Labot koordinatoru",
    "notifications.authorization_code_is_no_longer_valid": "Autorizēšanās kodam beidzies darbības termiņš",
    "button.reject": "Atgriezt",
    "label.label.participant_status": "Dalībnieka statuss",
    "award.gold_level": "Zelta līmenis",
    "sidebar.variables": "Mainīgie",
    "parentalConsent.checkbox_copy": "Es apstiprinu, ka esmu {firstName} {lastName} māte/tēvs / likumiskais pārstāvis. Es atļauju viņam/viņai piedalīties Award {organisationName} Award vadītāja pārraudzībā. Es iepazinos, saprotu un piekrītu prasībām un nosacījumiem par dalību Award kas aprakstīti augstāk un Nacionālā Award operatora mājaslapā.",
    "button.go_to_dashboard": "Doties uz paneli",
    "button.add_option": "Pievienot iespējas",
    "label.is_completed": "Pabeigts",
    "pageTitle.award_units": "Award vienības",
    "states.completed": "Pabeigts",
    "button.adventurous_journey_template_settings": "Piedzīvojumu ceļojuma veidnes iestatījumi",
    "label.system_rights": "Sistēmas tiesības",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Ielogoties",
    "label.name_of_the_unit": "Award vienības nosaukums",
    "button.send": "Sūtīt",
    "award.ajs": "Piedzīvojumu ceļojumi",
    "meta.payments_expired": "Maksājumi - kuru derīguma termiņš beidzies",
    "label.age": "Vecums",
    "notifications.payment_info_updated": "Informācija par maksājumu ir atjaunināta",
    "table.is_completed": "Pabeigts",
    "table.invited_by": "Uzaicināja",
    "route.files": "Faili",
    "route.assessors": "Novērtētāji",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Mani dalībnieki",
    "label.change_leader_status": "Mainīt vadītāja statusu",
    "moduleTitle.parent_consent_form": "Vecāku / likumisko pārstāvju atļaujas forma",
    "notifications.authorization_contact_has_been_set": "Pilnvarotā kontaktpersona ir noteikta",
    "button.close": "Aizvērt",
    "label.independent_country": "Neatkarīga valsts",
    "notifications.aj_preparation_training_has_been_returned": "Piedzīvojumu ceļojuma sagatavošanās un apmācības ir atgrieztas",
    "route.history_log": "Ierakstu vēsture",
    "participant.account_settings": "Konta iestatījumi",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "Konfigurācijā nav norādīta faila URL",
    "notifications.award_unit_has_been_removed": "Award vienība/Neatkarīgais Award centrs ir noņemts",
    "table.parent": "Vecāki",
    "label.mode_of_transport": "Pārvietošanās veids",
    "label.parental_consent_email_info": "",
    "label.current_award": "Šī brīža Award",
    "table.action": "Darbība",
    "pageTitle.suboperating_authorities": "Apakš-operatori",
    "notifications.award_leader_has_been_assigned": "Piešķirts Award vadītājs",
    "tabs.sign_offs_locally": "Vietējie apstiprinājumi",
    "Activity log has been restored": "Ieraksts par aktivitāti ir atgriezts",
    "sidebar.naos": "Nacionālie Award operatori",
    "tabs.aj_templates": "Piedzīvojumu ceļojuma veidnes",
    "notifications.logging_out": "Izlogošanās...",
    "label.update_label": "",
    "button.organisation_settings": "Organizācijas iestatījumi",
    "tabs.independent_award_centers": "Neatkarīgais Award centrs",
    "label.current": "",
    "table.location": "Vieta",
    "button.search": "Meklēt",
    "notifications.aj_preparation_training_has_been_approved": "Piedzīvojumu ceļojumu sagatavošanās un apmācības ir apstiprinātas",
    "route.participants": "Dalībnieki",
    "label.other_location_information": "Cita informācija par vietu",
    "label.number_of_records": "Ierakstu skaits",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "5. Es piekrītu apmaksāt visus attiecīgos ārstu, medpersonāla un izmitināšanas slimnīcā maksas pakalpojumus un izdevumus, kas radušies saistībā ar jebkuru negadījumu, traumu, slimību vai zaudējumu, kurus dalībnieks piedzīvo piedaloties vai dodoties uz/no aktivitātēm, kas saistītas ar Award.",
    "label.nationality": "Tautība",
    "states.approval": "Apstiprināšana",
    "notifications.something_went_wrong": "Kaut kas nogāja greizi",
    "aj.practice": "Izmēģinājuma",
    "label.addressLine2": "Address Second Line",
    "label.please_leave_a_note": "Lūdzam atstāt ziņu",
    "placeholder.select": "Izvēlēties",
    "label.observations": "Novērojumi",
    "label.aim": "Mērķis",
    "label.addressLine1": "Adrese",
    "roles.aj_instructor": "P.C.instruktors",
    "meta.payments_waiting": "Gaidošie maksājumi",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instruktors",
    "moduleTitle.remove_customization_and_reset": "Noņemt pielāgojumus un atjaunot konfigurācijas vērtību?",
    "notifications.participant_registration_has_been_restored": "Dalībnieka reģistrācija ir atjaunota",
    "organisation.change_award_unit_mode": "Mainīt organizācijas režīmu",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Dalībnieks ir izdzēsts",
    "label.language_settings": "Valodas iestatījumi",
    "notifications.event_has_been_approved": "Notikums ir apstiprināts",
    "label.password": "Parole",
    "label.text": "Teksts",
    "table.observations": "Novērojumi",
    "notifications.participant_has_been_created": "Dalībneiks ir izveidots",
    "table.note_for_al": "Ziņa Award vadītājam",
    "label.payment_confirmed": "Maksājums apstiprināts",
    "label.previous_completed_award_level": "Iepriekšējais līmenis (ārpus TSG)",
    "pageTitle.new_aj_event": "Jauns piedzīvojumu ceļojuma notikums",
    "label.backend": "",
    "label.relationship_to_participant": "Saistība ar dalībnieku",
    "award.physical_recreation": "Fiziskā sagatavotība",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Novērtētājs nepieņem pārskatu",
    "label.supervisor_report": "Uzrauga pārskats",
    "table.role": "Loma",
    "route.user_guide_web_nao": "Pamācība NAO - tīmekļa lietotājam",
    "label.page_not_found": "404 - lapa netika atrasta",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "Fails ir augšupielādēts",
    "moduleTitle.address": "Adrese",
    "moduleTitle.lead_coordinator": "Vadošais koordinators",
    "pageTitle.login": "Ielogoties",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Projekts ir izveidots",
    "moduleTitle.award_unit": "Award vienība",
    "button.remove_file": "Noņemt ierakstu",
    "moduleTitle.billing_address": "Adrese, uz kuru sūtīt rēķinu",
    "pageTitle.my_aj_events": "Mani piedzīvojumu ceļojuma notikumi",
    "route.tasks": "Uzdevumi",
    "button.confirm": "Apstiprināt",
    "label.national_award_authority": "Nacionālā Award autoritāte",
    "label.independent_award_centre": "Neatkarīgais Award centrs",
    "award.generate_award_report": "Izveidot pārskatu",
    "route.my_region_office_customization": "Mans reģionālais birojs - pielāgojumi",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Paroles maiņas pieprasījums ir nosūtīts",
    "tabs.detail": "Informācija",
    "participant.change_participant_status": "Mainīt dalībnieka statusu",
    "table.key": "",
    "label.find_address": "Atrast adresi",
    "notifications.assessor_has_been_rejected": "Novērtētājs ir noraidīts",
    "label.transfer_participants": "Nodot dalībniekus",
    "button.continue_to_payment_gateway": "Turpināt maksājuma izpildi",
    "notifications.participant_registration_has_been_removed": "Dalībnieka reģistrācija ir noņemta",
    "moduleTitle.page_not_found": "404 - lapa netika atrasta",
    "route.adventurous_journeys": "Piedzīvojumu ceļojumi",
    "states.registration_assessment": "Reģistrācijas novērtējums",
    "heading.change_award_unit_mode": "Mainīt Award vienības režīmu",
    "label.user_guide_web_nao": "Pamācība NAO - tīmekļa lietotājam",
    "tabs.silver_level": "Sudraba līmenis",
    "table.paid_by": "Maksājumu veica",
    "label.your_report_has_been_successfully_sent": "Tavs pārskats veiksmīgi nosūtīts.",
    "sidebar.my_organization": "Mana organizācija",
    "pageTitle.participants": "Dalībnieki",
    "notifications.preparation_training_has_been_updated": "Sagatavošanās un apmācības ir atjaunotas",
    "moduleTitle.server_is_unreachable": "Serveris nav sasniedzams",
    "label.last_activity_date": "",
    "award.bronze_level": "Bronzas līmenis",
    "moduleTitle.award_units": "Award vienības",
    "table.completed": "Pabeigts",
    "moduleTitle.revise_message": "Mainīt ziņu",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "",
    "button.change_password": "Mainīt paroli",
    "label.nao_price": "NAO cena",
    "label.payment_state": "Maksājuma statuss",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "Datums, kad nacionālais birojs apstiprināja apbalvojuma piešķiršanu",
    "label.award_unit": "Award vienība",
    "award.gold_level_short": "Zelts",
    "moduleTitle.other_info": "Cita informācija",
    "table.note": "Ziņa",
    "label.search_by_email_first_or_last": "Meklēt pēc e-pasta, vārda vai uzvārda",
    "tabs.history": "Vēsture",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Dalībnieki bez Award vadītāja",
    "table.main_award_leader": "Koordinators",
    "parentalConsent.i_as_the_parent": "3. Es apzinos, ka dažas aktivitātes var būt saistītas ar paaugstinātu risku. Es saprotu, ka visa atbildība par iespējamajiem riskiem, kas saistīti ar dalībnieka dalību Award, gulstas uz dalībnieku.",
    "label.state": "Statuss",
    "notifications.award_leader_has_been_removed": "Award vadītājs ir noņemts",
    "tabs.organization_detail": "Informācija par organizāciju",
    "table.operating_authorities": "Izpildoperatori",
    "label.available_labels": "",
    "modal.select": "Izvēlēties",
    "tabs.expired_payments": "Maksājumi, kuriem beidzies termiņš",
    "moduleTitle.note_for_al": "Ziņa Award vadītājam",
    "moduleTitle.confirm": "Apstiprināt",
    "notification.new_activity_added": "Ir pievienota jauna aktivitāte",
    "notifications.award_leader_has_been_moved": "Award vadītājs ir pārcelts",
    "label.award_mode": "Award režīms",
    "label.phone": "Tālrunis",
    "notifications.organization_has_been_updated": "Organizācija ir atjaunināta",
    "moduleTitle.assessor": "Novērtētājs",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Vecāku atļauja",
    "label.date_of_delivery": "Saņemšanas diena",
    "sidebar.assessors": "Novērtētāji",
    "label.journey_activity": "Ceļojuma aktivitāte",
    "award.inactive_award": "Neaktīvs Award",
    "label.end_date": "Beigu datums",
    "label.orb_testing": "",
    "label.no_activities": "Nav aktivitāšu",
    "moduleTitle.please_confirm": "Lūdzu, apstiprini",
    "button.login_with_another_account": "Ielogoties, izmantojot citu profilu",
    "tasks.reject_registration": "Atgriezt reģistrāciju",
    "label.submitted_after_date": "Iesniegts pēc",
    "label.update_translations_successful": "",
    "button.assign_leader": "Piešķirt vadītāju",
    "table.already_running": "Jau darbojas",
    "label.no": "Nē",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "Sekundārais tālruņa numurs",
    "label.my_experience": "Mana pieredze",
    "notifications.adventurous_journey_has_been_approved": "Piedzīvojumu ceļojums ir apstiprināts",
    "pageTitle.mro_detail": "Mans reģionālais birojs - informācija",
    "moduleTitle.nao_specific_info": "NAO specifiskā informācija",
    "label.preparing_document_for_import": "Dokumenta sagatavošana importēšanai",
    "tasks.observations": "Novērojumi",
    "notifications.confirmation_email_has_been_sent": "Apstiprinājuma e-pasts ir nosūtīts",
    "button.restore": "Atjaunot",
    "label.importing_file": "Faila importēšana",
    "label.or_dont_agree": "Vai nepiekrīti? Tu vari",
    "moduleTitle.award_leader": "Award vadītājs",
    "label.me": "(es)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Eksportēt tabulu",
    "organisation.move_award_unit": "Pārvietot Award vienību",
    "label.file_category": "",
    "notifications.connecting_to_server": "Savienojas ar serveri...",
    "parentalConsent.i_understand_that_a_and_b": "11. Es saprotu, ka: \n<br /> a. kamēr nav iegūtas attiecīgās tiesības un nav veikta attiecīgā apdrošināšana, dalībnieks nedrīkst vadīt motorizētu transportlīdzekli vai pārvadāt citus dalībniekus uz aktivitātēm, kas saistītas ar Award; un\n<br /> b. dalībnieku nedrīkst pārvadāt personas, kuras nav saistītas ar Award organizēšanu vai tās atbalstīšanu.",
    "table.reason": "",
    "pageTitle.contacts": "Kontakti",
    "states.award_leader_approval": "Award vadītāja apstiprinājums",
    "meta.payments": "Maksājumi",
    "label.suboperating_authority": "Apakš-operatori",
    "route.my_region_office": "Mans reģionālais birojs",
    "states.registration_not_approved": "Reģistrācija nav apstiprināta",
    "label.direct_entrant": "Tiešais iesācējs",
    "tabs.all_participants": "Visi dalībnieki",
    "tabs.payment": "Maksājums",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Atkārtot paroli",
    "label.other_roles": "",
    "logs.hours": "stundas",
    "notifications.spreadsheet_has_been_imported_successfully": "Izklājlapa veiksmīgi importēta",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Tavi dati",
    "label.bulk_action_emailing": "",
    "route.my_events": "Mani notikumi",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Iekļauj gan mazos, gan lielos burtus",
    "tabs.removed_participant_registrations": "Noņemtās dalībnieku reģistrācijas",
    "sidebar.mynao": "Mans NAO",
    "tabs.office_details": "Informācija par biroju",
    "label.major": "\"Garākā joma\"",
    "tabs.documents": "Dokumenti",
    "label.new_password": "Jaunā parole",
    "sidebar.adventure_journey": "Piedzīvojumu ceļojums",
    "pageTitle.customizations": "Pielāgojumi",
    "moduleTitle.assessor_report": "{role} pārskats",
    "label.registration_date": "Reģistrēšanas datums",
    "notifications.training_has_been_added": "Apmācības ir pievienotas",
    "aj.qualifying": "Ieskaites",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Darba seansa laika limits beidzies, seanss pārtraukts.",
    "award.service": "Brīvprātīgais darbs",
    "notifications.rp_state_has_been_changed": "Projekta stāvoklis ir mainīts",
    "label.ctest_access": "",
    "table.created": "Izveidots",
    "tasks.revise_task": "Atgriezt uzdevumu",
    "button.assign": "Piešķirt",
    "button.return": "Atgriezt",
    "table.status": "Statuss",
    "button.restore_activity": "Atgriezt aktivitāti",
    "tabs.new_aj_event": "Jauns piedzīvojumu ceļojuma notikums",
    "roles.if_staff_viewer": "IF Staff Viewer",
    "notifications.new_template_has_been_created": "Izveidota jauna veidne",
    "global.something_went_wrong": "Kaut kas notika nepareizi",
    "table.expire_day": "Derīguma termiņš",
    "tabs.history_log": "Ierakstu vēsture",
    "label.form_of_payment": "Maksāšanas forma",
    "button.add_training": "Pievienot apmācības",
    "label.par_reg_cust_note": "",
    "label.my_qualification": "Mana kvalifikācija",
    "button.add_new_profile_question": "Pievienot jaunu profila jautājumu",
    "table.operating_authority": "Nacionālā autoritāte",
    "table.aim": "Mērķis",
    "table.awards": "Apbalvojumi",
    "participant.deactivate_account": "Deaktivizēt kontu",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Datums",
    "tasks.would_you_like_to_delete": "Vai vēlies dzēst šo dalībnieku?",
    "notifications.configuration_value_has_been_updated": "Konfigurācijas vērtība ir atjaunināta",
    "ajTemplates.fill_from_template": "Aizpildīt no veidnes",
    "contact.send_test_email": "Sūtīt izmēģinājuma e-pastu",
    "moduleTitle.aj_preparation_and_training": "Piedzīvojumu ceļojuma apmācības un sagatavošanās",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "Tēva vai mātes / likumiskā pārstāvja tālruņa numurs",
    "label.nao_regulations": "",
    "award.skills": "Prasmes",
    "label.reject_application": "noraidīt šo pieteikumu.",
    "leader.delete_account": "Dzēst kontu",
    "table.assign": "Piešķirt",
    "roles.aj_supervisor": "Piedzīvojumu ceļojuma uzraugs",
    "label.logout": "Izlogoties",
    "moduleTitle.award_leader_edit": "Labot Award vadītāju",
    "moduleTitle.training": "Apmācības",
    "notifications.coordinator_has_been_removed": "Koordinators ir noņemts",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Koordinators",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "Sagatavošanās",
    "table.delete": "Dzēst",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Pārskati",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "Izpildoperatori",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Apstiprināts",
    "notifications.invitation_has_been_sent": "Uzaicinājums ir nosūtīts",
    "pageTitle.independent_countries": "Neatkarīgās valstis",
    "label.assessors_email": "Novērtētāja e-pasts",
    "tasks.approve_assessor_registration": "Apstiprināt novērtētāja reģistrāciju",
    "table.award_duration": "Award ilgums",
    "notifications.organization_has_been_moved": "Organizācija ir pārcelta",
    "pageTitle.nao_payment": "Nacionālais birojs - maksājums",
    "participant.history_log": "Ierakstu vēsture",
    "label.rejected_with_note": "",
    "label.already_running": "Jau darbojas",
    "button.continue": "",
    "award.no_data_to_show": "Nav datu, ko parādīt",
    "participant.send_email_invitation_again_question": "Nosūtīt uzaicinājumu uz e-pastu vēlreiz?",
    "label.reason_for_changing_assessor": "Iemesls, kādēļ tika mainīts novērtētājs",
    "button.delete": "Dzēst",
    "moduleTitle.requirements_and_conditions": "Prasības un nosacījumi",
    "roles.leader": "Vadītājs",
    "label.if_download_doesnt": "",
    "dashboard.your_todo_list": "Tavs darāmo lietu saraksts",
    "notifications.award_unit_has_been_returned": "Award vienība ir atgriezta",
    "moduleTitle.participant_activities": "Dalībnieka aktivitātes",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Aktīvie vadītāji",
    "aj.preparation": "Sagatavošanās",
    "button.change_state": "Mainīt statusu",
    "label.current_password": "Šī brīža parole",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Kontaktu iestatījumi",
    "button.remove_photo": "Noņemt foto",
    "notifications.activity_has_been_setup": "Aktivitāte ir izveidota",
    "errors.must_be_more_than": "Vajag būt vairāk pat {limit}",
    "table.goal": "Mērķis",
    "notifications.coordinator_has_been_set": "Koordiantors ir noteikts",
    "label.cc": "Cc",
    "label.duration": "Ilgums",
    "table.actions": "Darbības",
    "participant.send_email_invitation_again": "Nosūtīt uzaicinājumu uz e-pastu vēlreiz?",
    "moduleTitle.would_you_like_to_remove_participant": "Vai vēlies dzēst šī dalībnieka reģistrāciju?",
    "parentalConsent.i_authorise_employees": "4. Es pilnvaroju Award vienības darbiniekus, amatpersonas vai pārstāvjus un citas personas, kas piedalās vai atbalsta Award organizēšanu, gadījumā, ja notiek negadījums, tiek gūts ievainojums, saslimšanas vai zaudējuma gadījumā, kamēr dalībnieks piedalās vai dodas no/uz aktivitāti, kad saistīta ar Award, lūgt jebkādu nepieciešamo medicīnisko palīdzību vai ārstēšanu, iesaistot, bet ne tikai, ārstu, medpersonāla vai izmitināšanu slimnīcā.",
    "button.reload_page": "Pārlādēt lapu",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "E-pasts",
    "label.new_goal": "Jauns mērķis",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Nederīgs e-pasta adreses formāts",
    "pageTitle.new_contact": "Jauns kontakts",
    "sidebar.gops": "",
    "button.manage_participants": "Pārvaldīt dalībniekus",
    "errors.invalid_phone_format": "Nederīgs tālruņa numura formāts",
    "notifications.login_details_have_been_changed": "Ielogošanās informācija ir mainīta",
    "moduleTitle.participant_logs": "Dalībnieka ieraksti",
    "label.save": "Saglabāt",
    "label.frequently_asked_questions": "Biežāk uzdotie jautājumi (BUJ)",
    "label.city": "Pilsēta",
    "notifications.configuration_value_has_been_reset": "Konfigurācijas vērtība ir atjaunota",
    "states.office_sign_off": "Nacionālā biroja apstiprinājums apbalvojuma piešķiršanai",
    "button.save": "Saglabāt",
    "button.import_data_from_selected_file": "Importēt datus no atlasītā faila",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Es saprotu, ka dalībnieks nevar sākt jebkuras Award jomas aktivitāti, kamēr es neesmu pārliecināts/-a, ka brīvprātīgais, kurš nav Award vienības pārstāvis, ko dalībnieks ir izvēlējies, ir pietiekoši pieredzējis un/vai kvalificēts, lai instruētu/uzraudzītu/novērtētu konkrēto Award jomu; un līdz brīdim, kamēr attiecīgais brīvprātīgais nav aizpildījis un iesniedzis nepieciešamos dokumentus Award vienībā.",
    "pageTitle.apiKeys": "",
    "label.international_region": "Starptautiskais reģions",
    "tabs.levels": "Līmeņi",
    "tabs.additional_files": "Papildu fiali",
    "label.continuation_level": "Turpinājuma līmenis",
    "table.adventurous_journey_detail": "Informācija par piedzīvojumu ceļojumu",
    "button.set": "Uzstādīt",
    "label.i_certify_that_as_the_assessor": "Es kā šīs aktivitātes {role} apliecinu to, ka dalībnieks ir izpildījis visas prasības.",
    "table.coordinator": "Koordinators",
    "participant.send_confirmation_email_again": "Nosūtīt apstiprinājuma e-pastu vēlreiz?",
    "table.report": "Pārskats",
    "label.update_translations_results": "",
    "table.observation_note": "Novērojumu piezīmes",
    "label.view_more": "Skatīt vairāk",
    "notifications.payment_link_has_been_reset": "Saite uz maksājumu ir atjaunota",
    "table.type": "Veids",
    "moduleTitle.updateConfigurationKey": "Atjaunināt konfigurācijas atslēgu",
    "sidebar.independent_award_centers": "Neatkarīgie Award centri",
    "table.activity_type": "Aktivitātes veids",
    "label.awardMode.online": "Tiešsaistē",
    "table.data_state": "",
    "button.generate_report": "Izveidot pārskatu",
    "moduleTitle.assessed_by_award_leader": "Novērtēja Award vadītājs",
    "table.child_protection_number": "Child Protection Number",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Award statuss",
    "moduleTitle.overview": "Pārskats",
    "table.aj_detail": "Informācija par piedzīvojumu ceļojumu",
    "pageTitle.tasks_activity_approvals": "Aktivitāšu apstiprināšana",
    "label.section": "Joma",
    "route.history": "Vēsture",
    "route.event_participants": "Notikuma dalībnieki",
    "participant.account_detail": "Konta iestatījumi",
    "route.dashboard": "Panelis",
    "table.payments": "Maksājumi",
    "pageTitle.profile": "Profils",
    "organisation.remove_organisation": "Noņemt organizāciju",
    "pageTitle.my_organization": "Mana organizācija",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "Novērtētājs ir atjaunināts",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "DUKE",
    "table.qualifying": "Ieskaites",
    "button.upload": "Augšupielādēt",
    "button.resend": "Sūtīt vēlreiz",
    "label.filename": "Faila nosaukums",
    "label.change_parental_consent": "",
    "button.cancel": "Atcelt",
    "label.aply_to_all_langs": "",
    "route.customization": "Pielāgošana",
    "errors.minimal_duration_is": "Minimālais ilgums 30 min",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Dalībnieka statuss",
    "award.bronze_level_short": "Bronza",
    "label.phone_type": "Tālruņa veids",
    "global.night": "nakts",
    "button.adventurous_journey_settings": "Piedzīvojumu ceļojuma iestatījumi",
    "participant.leader_must_be_selected": "Jānorāda Award vadītājs",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Lietotāja pievienotās apmācības un sagatavošanās",
    "table.approve": "Apstiprināt",
    "label.role_in_organisation": "Loma organizācijā",
    "states.finished": "Pabeigts",
    "label.created": "Izveidots",
    "button.back_to_home": "Uz sākumlapu",
    "label.options": "Iespējas",
    "contact.next_level_invitation": "Nākamā līmeņa uzaicinājums",
    "moduleTitle.activity_detail": "Informācija par aktivitāti",
    "route.section_signoff": "Jomas pabeigšanas apstiprināšana",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Kontakta iestatījumi",
    "label.transation_id": "Transakcijas ID",
    "notifications.activity_has_been_updated": "Aktivitāte ir atjaunināta",
    "sidebar.awards": "Award",
    "parentalConsent.images_consent": "Kā viens no vecākiem / likumiskais pārstāvis, es dodu savu piekrišanu tam, ka jebkās bildes var tikt izmantotas Fonda veidotajās reklāmās.",
    "participant.would_you_like_to_delete": "Vai vēlies dzēst šo kontu?",
    "roles.user": "Lietotājs",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "Nav rezultātu",
    "moduleTitle.address_line_2": "Address Second Line",
    "states.awaiting_office_sign_off": "Nacionālā biroja apstiprinājums apbalvojuma piešķiršanai",
    "moduleTitle.export": "Eksportēt",
    "moduleTitle.address_line_1": "Adrese",
    "notifications.participant_has_been_assigned": "Dalībnieks ir uzticēts",
    "roles.viewer": "Skatītājs",
    "label.participants_total": "Dalībnieki kopumā",
    "errors.auth_code_is_no_longer_valid": "Autorizācijas kods nav derīgs - iespējams, tas ir izmantots iepriekš vai tam beidzies darbības termiņš",
    "label.file_is_not_available": "Fails nav pieejams",
    "button.select_template": "Izvēlēties veidni",
    "label.payment": "Maksājums",
    "award.silver_level_short": "Sudrabs",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "Informācija par tevi",
    "aj.minimum_date_recommendation": "Ieteicamais laiks izmēģinājuma P.C. un {name} is",
    "label.date_of_payment": "Maksājuma veikšanas diena",
    "button.view": "Skatīt",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "Izveidot dalībnieku",
    "roles.assessor": "Novērtētājs",
    "moduleTitle.coordinator_settings": "Koordinatora iestatījumi",
    "label.parent_relationship": "Radniecība / saistības",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "E-pasts ir nosūtīts",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Apakš-operatori",
    "route.award": "Award",
    "label.no_roles": "Nav lomu",
    "table.files": "Faili",
    "aj.minimum_date_requirements": "Minimālās ieskaites P.C. un {name} laika prasības ir",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Dalībnieks ir bezsaistē",
    "moduleTitle.other_coordinators": "Citi koordinatori",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "Apstiprināt Award reģistrāciju",
    "participant.invite_participant_to_next_level": "Uzaicināt dalībnieku uz nākamo līmeni?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Apbalvojumi",
    "warning.award_marked_as_paid": "",
    "table.edit": "Pārskatīt",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "Starptautiskais Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "Pēc tam, kad piešķirsi vai mainīsi savu lomu, tev vajadazēs ielogoties no jauna.",
    "label.transaction_id": "Transakcijas ID",
    "table.suboperating_authority": "Apakšoperators",
    "label.participant_survey": "Kā Award dalībnieks es priecāšos piedalīties Fonda piedāvātajā aptaujā",
    "label.created_by": "Izveidoja",
    "button.send_confirmation_email_again_question": "Sūtīt apstiprinājuma e-pastu vēlreiz",
    "label.email_help_award_leader_email": "",
    "label.name": "Vārds",
    "tabs.gold_level": "Zelta līmenis",
    "pageTitle.award_documents": "Award dokumenti",
    "label.online_payments": "Tiešsaistes maksājumi",
    "label.child_protection_number": "Child Protection Number",
    "participant.send_password_recovery_email": "Nosūtīt paroles atjaunošanas e-pastu?",
    "notifications.new_log_has_been_added": "Pievienots jauns ieraksts",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Organizācijas nosaukums",
    "pageTitle.my_organization_templates": "Mana organizācija - veidnes",
    "pageTitle.award_leaders": "Award vadītāji",
    "label.status": "Statuss",
    "label.street": "Iela",
    "roles.if_staff_superuser": "IF Staff Superuser",
    "table.licence_holder": "Licencētā organizācija",
    "label.created_at": "Izveidots",
    "table.section": "Joma",
    "table.system_rights": "Sistēmas tiesības",
    "label.iac_type": "Neatkarīgā Award centra veids",
    "label.other": "Cits",
    "moduleTitle.login": "Ielogoties",
    "label.no_data_to_show": "Nav datu, ko parādīt",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Nevar mainīt Award līmeni, ja dalībnieks ir saistīts ar piedzīvojumu ceļojumu",
    "tabs.waiting_payments": "Gaida uz maksājumi",
    "global.supervisor": "Uzraugs",
    "notifications.new_role_has_been_added": "Pievienota jauna loma",
    "award.silver_level": "Sudraba līmenis",
    "heading.change_awards_mode": "Mainīt Award režīmu",
    "button.save_changes": "Saglabāt izmaiņas",
    "organisation.would_you_like_to_move_award_unit": "Uz kurieni vēlies pārcelt organizāciju?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Mans reģionālais birojs - informācija",
    "table.started_at": "Uzsākts",
    "parentalConsent.i_consent_to_the_award_unit": "2. Es piekrītu tam, ka Award vienība vai jebkurš individīds, ieskaitot brīvprātīgos*, kuri saistīti ar vai atbalsta Award, vai nolīgts transportlīdzekļa vadītājs, transportē dalībnieku, lai viņš varētu piedalītiess ar Award saistītās aktivitātes un pasākumos. Es saprotu, ka Award vienība man paziņos, kad un kur šādi pārvadājumi notiks.",
    "logs.minutes": "minūtes",
    "label.total_participants": "Dalībnieki kopumā",
    "moduleTitle.contact_info": "Kontaktinformācija",
    "table.payment_link": "Saite uz maksājumu",
    "errors.please_contact_your_local_award_staff": "Lūdzam sazināties ar vietējiem Award pārstāvjiem"
}